export const messages = {
  en: {
    contract: {
      renewContract: 'Renew Contract',
      draftContract: 'Draft Contract',
      parentContractName: 'Parent Contract Name',
      parentContractCode: 'Parent Contract Code',
      parentContractStatus: 'Parent Contract Status',
      contractName: 'Contract Name',
      requiredContractName: 'Required, please fill in contract name',
      contractCode: 'Contract Code',
      requiredContractCode: 'Required, please fill in contract code',
      contractType: 'Contract Type',
      requiredContractType: 'Required, please select contract type',
      partyA: 'Party A',
      requiredPartyA: 'Required, please select Party A',
      partyAContact: 'Party A Contact',
      partyAPhone: 'Party A Phone',
      partyB: 'Party B',
      partyBContact: 'Party B Contact',
      partyBPhone: 'Party B Phone',
      operator: 'Operator',
      operatorPhone: 'Operator Phone',
      contractAmount: 'Contract Amount',
      startTime: 'Start Time',
      requiredStartTime: 'Required, please fill in start time',
      endTime: 'End Time',
      requiredEndTime: 'Required, please fill in end time',
      signingTime: 'Signing Time',
      requiredSigningTime: 'Required, please fill in signing time',
      contractAttachments: 'Contract Attachments',
      addAttachment: 'Add Attachment',
      attachment: 'Attachment',
      deleteAttachment: 'Delete Attachment',
      relatedRooms: 'Related Rooms',
      add: 'Add',
      room: 'Room',
      owner: 'Owner',
      phone: 'Phone',
      builtUpArea: 'Built-up Area',
      squareMeter: 'Square Meter',
      roomStatus: 'Room Status',
      select: 'Select',
      approverInfo: 'Approver Information',
      organization: 'Organization',
      requiredOrganization: 'Required, please fill in organization',
      staff: 'Staff',
      requiredStaff: 'Required, please fill in staff',
      requiredNextHandler: 'Required, please select next handler',
      selectStaff: 'Select Staff',
      orgInfo: 'Organization Information',
      staffInfo: 'Staff Information',
      submitter: 'Submitter',
      dynamicAssign: 'Dynamic Assign',
      selectRoom: 'Select Room',
      inputBuildingNum: 'Input building number',
      inputRoomNum: 'Input room number',
      roomId: 'Room ID',
      buildingNum: 'Building Number',
      building: 'Building',
      unitNum: 'Unit Number',
      unit: 'Unit',
      roomNum: 'Room Number',
      floor: 'Floor',
      floorUnit: 'Floor',
      selectOwner: 'Select Owner',
      inputRoomFullNum: 'Input room full number (Building-Unit-Room)',
      inputOwnerName: 'Input owner name',
      ownerId: 'Owner ID',
      name: 'Name',
      personType: 'Person Type',
      personRole: 'Person Role',
      idCard: 'ID Card',
      contact: 'Contact',
      submitSuccess: 'Submit successfully',
      invalidFileType: 'Operation failed, please upload image or PDF format files',
      required: 'Required',
      requiredOperator: 'Required, please fill in operator',
      requiredOperatorPhone: 'Required, please fill in operator phone',
      requiredContractAmount: 'Required, please fill in contract amount'
    }
  },
  zh: {
    contract: {
      renewContract: '续签合同',
      draftContract: '起草合同',
      parentContractName: '父合同名称',
      parentContractCode: '父合同编号',
      parentContractStatus: '父合同状态',
      contractName: '合同名称',
      requiredContractName: '必填，请填写合同名称',
      contractCode: '合同编号',
      requiredContractCode: '必填，请填写合同编号',
      contractType: '合同类型',
      requiredContractType: '必填，请选择合同类型',
      partyA: '甲方',
      requiredPartyA: '必填，请选择甲方',
      partyAContact: '甲方联系人',
      partyAPhone: '甲方联系电话',
      partyB: '乙方',
      partyBContact: '乙方联系人',
      partyBPhone: '乙方联系电话',
      operator: '经办人',
      operatorPhone: '联系电话',
      contractAmount: '合同金额',
      startTime: '开始时间',
      requiredStartTime: '必填，请填写开始时间',
      endTime: '结束时间',
      requiredEndTime: '必填，请填写结束时间',
      signingTime: '签订时间',
      requiredSigningTime: '必填，请填写签订时间',
      contractAttachments: '合同附件',
      addAttachment: '添加附件',
      attachment: '附件',
      deleteAttachment: '删除附件',
      relatedRooms: '关联房屋',
      add: '添加',
      room: '房屋',
      owner: '业主',
      phone: '电话',
      builtUpArea: '建筑面积',
      squareMeter: '平方米',
      roomStatus: '房屋状态',
      select: '选择',
      approverInfo: '审批人信息',
      organization: '所属组织',
      requiredOrganization: '必填，请填写所属组织',
      staff: '员工',
      requiredStaff: '必填，请填写所属员工',
      requiredNextHandler: '必填，请选择下一处理人',
      selectStaff: '选择员工',
      orgInfo: '组织信息',
      staffInfo: '员工信息',
      submitter: '提交者',
      dynamicAssign: '动态指定',
      selectRoom: '选择房屋',
      inputBuildingNum: '输入小区楼编号',
      inputRoomNum: '输入房屋编号',
      roomId: '房屋ID',
      buildingNum: '楼栋编号',
      building: '号楼',
      unitNum: '单元编号',
      unit: '单元',
      roomNum: '房屋编号',
      floor: '楼层',
      floorUnit: '层',
      selectOwner: '选择业主',
      inputRoomFullNum: '输入房屋编号(楼栋-单元-房屋)',
      inputOwnerName: '输入业主名称',
      ownerId: '业主编号',
      name: '名称',
      personType: '人员类型',
      personRole: '人员角色',
      idCard: '证件号',
      contact: '联系方式',
      submitSuccess: '提交成功',
      invalidFileType: '操作失败，请上传图片、PDF格式的文件',
      required: '必填',
      requiredOperator: '必填，请填写经办人',
      requiredOperatorPhone: '必填，请填写联系电话',
      requiredContractAmount: '必填，请填写合同金额'
    }
  }
}